<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#1354f4" type="line-spin-fade-rotating"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner><ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade-rotating"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="page">
  <div class="main-header side-header sticky">
    <div class="main-container container-fluid">
      <div class="main-header-left">
        <a class="main-header-menu-icon" href="javascript:void(0)" id="mainSidebarToggle"><span></span></a>
        <div class="hor-logo">
          <a class="main-logo" href="index.html">
            <img src="./assets/img/logo-light.png" class="header-brand-img desktop-logo" alt="logo">
            <img src="./assets/img/logo-light.png" class="header-brand-img desktop-logo-dark" alt="logo">
          </a>
        </div>
      </div>
      <div class="main-header-center">
        <div class="responsive-logo">
          <a href="#"><img src="./assets/img/logo-light.png" class="mobile-logo" alt="logo"></a>
          <a href="#"><img src="./assets/img/logo-light.png" class="mobile-logo-dark" alt="logo"></a>
        </div>
        <div class="input-group">
          <!-- <div class="session-div">
            <h6 class="session-h">Current Session - {{umsService.secretdata['SnName']}}</h6>
          </div> -->
        </div>
      </div>
      <div class="main-header-right">
        <button class="navbar-toggler navresponsive-toggler" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent-4" aria-controls="navbarSupportedContent-4" aria-expanded="false"
          aria-label="Toggle navigation">
          <i class="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
        </button>
        <div class="navbar navbar-expand-lg  nav nav-item  navbar-nav-right responsive-navbar navbar-dark  ">
          <div class="collapse navbar-collapse" id="navbarSupportedContent-4">
            <div class="d-flex order-lg-2 ms-auto">
              <div class="dropdown header-search">
                <a class="nav-link icon header-search">
                  <i class="fe fe-search header-icons"></i>
                </a>
                <div class="dropdown-menu">
                  <div class="main-form-search p-2">
                    <div class="input-group">
                      <div class="input-group-btn search-panel">
                        <select class="form-control select2">
                          <option label="All categories">
                          </option>
                          <option value="IT Projects">
                            IT Projects
                          </option>
                          <option value="Business Case">
                            Business Case
                          </option>
                          <option value="Microsoft Project">
                            Microsoft Project
                          </option>
                          <option value="Risk Management">
                            Risk Management
                          </option>
                          <option value="Team Building">
                            Team Building
                          </option>
                        </select>
                      </div>
                      <input type="search" class="form-control " placeholder="Search for anything...">
                      <button class="btn search-btn"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                          viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" class="feather feather-search">
                          <circle cx="11" cy="11" r="8"></circle>
                          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg></button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <h6 class="margin">{{userData.LoginFullName}}</h6>
              </div>
              <button (click)="zoom('-')" title="Set to Small Font"
                class="text-white border border-white rounded-md text-sm A-">A-</button>
              <button (click)="zoom('A')" title="Set To Medium Font"
                class="text-white border border-white rounded-md text-sm A">A</button>
              <button (click)="zoom('+')" title="Set To Large Font"
                class="text-white border border-white rounded-md text-sm Fl">A+</button>
              <div class="dropdown main-header-notification flag-dropdown">
                <a class="nav-link icon country-Flag" (click)="redirectProcessing(switchsession)">
                  <i class="fa fa-retweet header-icons header-icons"></i>
                </a>
              </div>
              <div class="dropdown main-header-notification flag-dropdown">
              </div>
              <div class="dropdown main-header-notification flag-dropdown">
              </div>
              <div class="dropdown ">
                <a class="nav-link icon full-screen-link">
                  <i class="fe fe-maximize fullscreen-button fullscreen header-icons"></i>
                  <i class="fe fe-minimize fullscreen-button exit-fullscreen header-icons"></i>
                </a>
              </div>
              <div class="dropdown main-header-notification" #notificationDropdown>
                <a class="nav-link icon" href="">
                  <i class="fe fe-bell header-icons"></i>

                  <span class="badge bg-danger nav-link-badge">{{NotificationCount}}</span>
                </a>

                <div class="dropdown-menu" *ngIf="NotificationsData?.length > 0">
                  <div class="header-navheading">
                    <p *ngIf="NotificationCount === 1" class="main-notification-text">You have {{NotificationCount}}
                      unread notification</p>
                    <p *ngIf="NotificationCount > 1" class="main-notification-text">You have {{NotificationCount}}
                      unread notifications</p>
                  </div>
                  <div class="main-notification-list">
                    <div class="media" *ngFor="let notification of NotificationsData | slice:0:3">
                      <div class="media-body">
                        <p>
                          <strong>{{ notification.title }} : </strong> {{ notification.description }}
                        </p>
                        <span>{{ notification.date | date:'dd/MM/yyyy' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-footer">
                    <a href="javascript:void(0)" (click)="ShowNotification(notificationDropdown)">View All
                      Notifications</a>
                  </div>
                </div>
              </div>
              <div class="dropdown main-profile-menu">
                <a class="d-flex" href="javascript:void(0)">
                  <span class="main-img-user"><img alt="avatar" src="./assets/img/woman.png"></span>
                </a>
                <div class="dropdown-menu">
                  <div class="header-navheading">
                    <h6 class="main-notification-title">{{userData.LoginFullName}}</h6>
                  </div>

                  <a class="dropdown-item border-top" (click)="changePassword()">
                    <i class="fa fa-lock"></i> Change Password
                  </a>
                  <a class="dropdown-item" href="#" (click)="logout()">
                    <i class="fe fe-power"></i> Sign Out
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Main Header-->

  <!-- Sidemenu -->
  <div class="sticky">
    <div class="main-menu main-sidebar main-sidebar-sticky side-menu">
      <div class="main-sidebar-header main-container-1">
        <div class="sidemenu-logo style1 ">
          <a class="main-logo">
            <img src="./assets/img/logo-light.png" class="header-brand-img desktop-logo style2" alt="logo">
            <img src="./assets/img/icon-light.png" class="header-brand-img icon-logo" alt="logo">
            <img src="./assets/img/logo-light.png" class="header-brand-img desktop-logo theme-logo" alt="logo">
            <img src="./assets/img/icon.png" class="header-brand-img icon-logo theme-logo" alt="logo">
          </a>
        </div>
        <div class="main-sidebar-body main-body-1 scrollll border-Right pt-0">
          <div class="slide-left disabled" id="slide-left"><i class="fe fe-chevron-left"></i></div>
          <ul class="menu-nav nav">
            <li *ngIf="dashboardMenu" class="nav-item active show" id="dashboard" (click)="changetheme('dashboard')">
              <a class="nav-link with-sub" (click)="redirect('home')">
                <!-- <i class="fa fa-home sidemenu-icon menu-icon "></i> -->
                <i class="fa fa-home sidemenu-icon menu-icon "></i>
                <!-- <i class="fa-solid fa-gauge"></i> -->
                <!-- <i class="fa-solid fa-gauge-high"></i> -->
                <span class="sidemenu-label">Dashboard</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <!-- <ul hidden="true" class="nav-sub">
                <li class="nav-sub-item"><a class="nav-sub-link" href="home">Parent-Dashbaord</a></li>
              </ul> -->
            </li>


            <li style="margin-top: 3rem;" *ngIf="TeacherLogin" class="nav-sub-item" (click)="$event.stopPropagation()">
              <a id="EditTeacherProfile" class="nav-sub-link" [routerLink]="['/EditTeacherProfile']">
                Edit Teacher Profile
              </a>
            </li>

            <li *ngIf="masterMenu" class="nav-item" id="master" (click)="changetheme('master')"
              (click)="toggleSubMenu('master')">
              <a class="nav-link with-sub">
                <!-- fa-graduation-cap -->

                <i class="fa fa-id-card-o sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Masters</span>
                <i class="angle fe fe-chevron-right"></i>
                <!-- <i class="angle fe" [class.fe-chevron-right]="!isMenuActive('master')" [class.fe-chevron-down]="isMenuActive('master')"></i> -->
              </a>
              <ul class="nav-sub minmaxadmin" [hidden]="!isMenuActive('master')">
                <li class="side-menu-label1"></li>
                <!-- <li class="nav-sub-item" *ngFor="let header of headerlist.master;"><a class="nav-sub-link" [id]="header.master_name"  
                    (click)="redirect(header.path);colorchnage(header.master_name)">
                    {{header.master_name}}
                  </a></li> -->
                <li *ngIf="FacultyView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Faculty"
                    class="nav-sub-link" [routerLink]="['/faculty-data']">
                    {{'header.faculty-data.titleList.Faculty'
                    | translate}}
                  </a></li>
                <li *ngIf="CollegeView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="College"
                    class="nav-sub-link" [routerLink]="['/college-data']">
                    {{'header.college-data.table.College'
                    | translate}}
                  </a></li>
                <li *ngIf="CourseView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Course"
                    class="nav-sub-link" [routerLink]="['/course-data']">
                    Course/Branch
                  </a></li>
                     <li *ngIf="CoursewiseAttThresoldMasterView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Coursewise Attendance Threshold" class="nav-sub-link" [routerLink]="['/coursewise-att-thresold-master']">
                    Coursewise Attendance Threshold
                  </a></li>
                <li *ngIf="CollegeMappingView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="College Mapping" class="nav-sub-link" [routerLink]="['/college-mapping']">
                    College Mapping
                  </a></li>
                <li *ngIf="codetypeforadmin" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Code Type"
                    class="nav-sub-link" [routerLink]="['/code-type-data']">
                    Code Type
                  </a></li>
                <li *ngIf="ExamView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Exam"
                    class="nav-sub-link" [routerLink]="['/exam-data']">
                    {{'header.exam-data.table.Exam'| translate}}
                  </a></li>
                <li *ngIf="SubjectMappingView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Subject Setup" class="nav-sub-link" [routerLink]="['/exam-subject-setup']">
                    Subject Setup
                  </a></li>


                <li *ngIf="DepartmentView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Exam"
                    class="nav-sub-link" [routerLink]="['/Department']">
                    Department
                  </a></li>

                <li *ngIf="DepartmentSubjectMappingView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Exam" class="nav-sub-link" [routerLink]="['/Department-Subject-Mapping']">
                    Department Subject Mapping
                  </a></li>

                <li *ngIf="ExaminerView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Teacher"
                    class="nav-sub-link" [routerLink]="['/Teacher-Data']">
                    Eligible Examiner Profile
                  </a></li>
                 <li *ngIf="ExaminerEligibility" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Examiner" class="nav-sub-link" [routerLink]="['/TeacherEligibility']">
                    Examiner Eligibility Add
                  </a></li>
                <li *ngIf="ExaminerAvailability" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Examiner" class="nav-sub-link" [routerLink]="['/TeacherAvailibilty']">
                    Examiner Availability Request
                  </a></li>
                <li *ngIf="PracticalExaminerAssignment" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Examiner" class="nav-sub-link" [routerLink]="['/AssignTeacher-Data']">
                    Practical Examiner Assignment
                  </a></li>
                  <li *ngIf="AssignPanelDate" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Assign Panel Date" class="nav-sub-link" [routerLink]="['/AssignPanelDate']">
                    Assign Panel Date
                  </a></li>
                <!-- <li *ngIf="ChoiceSubjectView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Choice Subjects" class="nav-sub-link" [routerLink]="['/Choice-Subjects']">
                    Choice Subjects
                  </a></li> -->
                <li *ngIf="CountryView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Country"
                    class="nav-sub-link" [routerLink]="['/country-data']">
                    {{'header.country-data.table.Country'| translate}}
                  </a></li>
                <li *ngIf="StateView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="State"
                    class="nav-sub-link" [routerLink]="['/state-data']">
                    {{'header.state-data.table.State'| translate}}
                  </a></li>
                <li *ngIf="DistrictView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="District"
                    class="nav-sub-link" [routerLink]="['/district-data']">
                    {{'header.district-data.table.District'| translate}}
                  </a></li>
                <li *ngIf="DivisionView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Division"
                    class="nav-sub-link" [routerLink]="['/division-data']">
                    {{'header.division-data.table.Division'| translate}}
                  </a></li>
                <li *ngIf="TownView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Town"
                    class="nav-sub-link" [routerLink]="['/town-data']">
                    {{'header.town-data.table.Town' | translate }}
                  </a></li>
                <li *ngIf="TehasilView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Tehasil"
                    class="nav-sub-link" [routerLink]="['/tehasil-data']">
                    <!-- {{'header.tehasil.title' | translate }} -->
                      Taluka
                  </a></li>
                   <li *ngIf="EligibilityCriteria" class="nav-sub-item" (click)="$event.stopPropagation()">
                    <a id="Eligibility" class="nav-sub-link" [routerLink]="['/eligibility-criteria']">
                    Eligibility Criteria
                  </a></li>
                <li *ngIf="AttendanceSettingView && !SkipAttendance" class="nav-sub-item"
                  (click)="$event.stopPropagation()"><a id="SubjectAttendanceThreshold" class="nav-sub-link"
                    [routerLink]="['/student-attendance-setting']">
                    Attendance Master
                  </a></li>
                <!-- <li *ngIf="IAAtdSettingView && !SkipAttendance" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="IAAttendanceThreshold" class="nav-sub-link" [routerLink]="['/ia-attendance']">
                    Practical Attendance Master
                  </a>
                </li> -->
                <!-- <li *ngIf="Cast" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Cast"
                    class="nav-sub-link" [routerLink]="['/category']">
                    Caste
                  </a></li>
                <li *ngIf="SubCast" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="SubCast"
                    class="nav-sub-link" [routerLink]="['/caste-master']">
                    Sub Caste
                  </a></li> -->

              </ul>
            </li>
            <!-- <li class="nav-item" id="location" (click)="changetheme('location')">
              <a class="nav-link with-sub" >
                <i class="fa fa-map-marker sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Location</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul class="nav-sub minmax ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" *ngFor="let header of headerlist.location;"><a  class="nav-sub-link"  [id]="header.master_name"  
                    (click)="redirect(header.path);colorchnage(header.master_name)">{{header.master_name}}</a></li>
              </ul>
            </li> -->
            <li *ngIf="adminMenu" class="nav-item" id="admin" (click)="changetheme('admin')"
              (click)="toggleSubMenu('admin')">
              <a class="nav-link with-sub">
                <i class="fa fa-user sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Admin</span>
                <i class="angle fe fe-chevron-right"></i>
                <!-- <i class="angle fe" [class.fe-chevron-right]="!isMenuActive('admin')" [class.fe-chevron-down]="isMenuActive('admin')"></i> -->
              </a>
              <ul class="nav-sub minmaxadmin" [hidden]="!isMenuActive('admin')">
                <li class="side-menu-label1"></li>
                <!-- <li class="nav-sub-item" *ngFor="let header of headerlist.admin;"><a class="nav-sub-link"
                    [id]="header.master_name"  
                    (click)="redirect(header.path);colorchnage(header.master_name)">{{header.master_name}}</a></li> -->

                <li *ngIf="SessionView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Session"
                    class="nav-sub-link" [routerLink]="['/session-data']">
                    Session
                  </a></li>
                <li *ngIf="CourseIntakeMappingView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Course Intake Mapping" class="nav-sub-link" [routerLink]="['/session-course-college']">
                    Course Intake Mapping
                  </a></li>
                <li *ngIf="CasteWiseIntakeView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Course Intake Mapping" class="nav-sub-link" [routerLink]="['/CasteWiseIntake']">
                    Caste Wise Intake
                  </a></li>
                <li *ngIf="SessionCutoffView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Session CutOff" class="nav-sub-link" [routerLink]="['/session-cutoff']">
                    Session CutOff
                  </a></li>
                <li *ngIf="SupervisorCourseView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Supervisor For Course" class="nav-sub-link" [routerLink]="['/supervisor-course']">
                    Supervisor For Course
                  </a></li>
                <li *ngIf="SupervisorExamView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Supervisor For Exam" class="nav-sub-link" [routerLink]="['/supervisor-exam']">
                    Supervisor For Exam
                  </a></li>
                <li *ngIf="UserPermissionView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Users"
                    class="nav-sub-link" [routerLink]="['/user-tab']">
                    Users
                  </a></li>
                <li *ngIf="AssignLevelView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Admission Approval Level" class="nav-sub-link" [routerLink]="['/assign-level']">
                    Admission Approval Level
                  </a></li>
                <!-- <li *ngIf="IAUserView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="IAUser" class="nav-sub-link" [routerLink]="['/Ia-User-Access']">
                    IA User Access
                  </a></li> -->
              </ul>
            </li>
            <li *ngIf="superMenu" class="nav-item" id="supervisor" (click)="changetheme('supervisor')"
              (click)="toggleSubMenu('supervisor')">
              <a class="nav-link with-sub">
                <i class="fa fa-user-secret sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Supervisor</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul class="nav-sub minmaxadmin" [hidden]="!isMenuActive('supervisor')">
                <li class="side-menu-label1"></li>
                <li *ngIf="ExamScheduleView" class="nav-sub-item" (click)="$event.stopPropagation()"> <a
                    id="Exam Schedule" class="nav-sub-link" [routerLink]="['/exam-schedule']">
                    Exam Schedule
                  </a></li>
                <li *ngIf="ExamEditScheduleView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Exam Edit Control" class="nav-sub-link" [routerLink]="['/exam-sc-edit']">
                    Exam Edit Control
                  </a></li>
                <li *ngIf="CourseScheduleView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Course Schedule" class="nav-sub-link" [routerLink]="['/course-schedule']">
                    Course Schedule
                  </a></li>
                <li *ngIf="CourseEditScheduleView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Course Edit Control" class="nav-sub-link" [routerLink]="['/course-sc-edit']">
                    Course Edit Control
                  </a></li>
                <li *ngIf="NewExamCodeView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="New Exam Codes" class="nav-sub-link" [routerLink]="['/new-exam-code']">
                    New Exam Codes
                  </a></li>
                <li *ngIf="ExamTimetableView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Exam TimeTable" class="nav-sub-link" [routerLink]="['/exam-timetable']">
                    Exam Time Table
                  </a></li>
                <li *ngIf="QuestionPaperCodesView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Question Papers Codes" class="nav-sub-link" [routerLink]="['/Question-Papers-Codes']">
                    Question Papers Codes
                  </a></li>
                <li *ngIf="PracticalTimeTable" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Practical TimeTable" class="nav-sub-link" [routerLink]="['/practicalTimeTable']">
                    Practical Time Table
                  </a></li>
                  <li *ngIf="PracticalBatch" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Practical TimeTable" class="nav-sub-link" [routerLink]="['/practicalBatch']">
                    Practical Batch
                  </a></li>
              </ul>
            </li>
            <li *ngIf="prcessMenu" class="nav-item" id="processing" (click)="changetheme('processing')"
              (click)="toggleSubMenu('processing')">
              <a class="nav-link with-sub">
                <i class="fa fa-book sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Processing</span>
                <i class="angle fe fe-chevron-right"></i>
                <!-- <i class="angle fe" [class.fe-chevron-right]="!isMenuActive('processing')" [class.fe-chevron-down]="isMenuActive('processing')"></i> -->
              </a>
              <ul class="nav-sub minmaxadmin" [hidden]="!isMenuActive('processing')">
                <li class="side-menu-label1"></li>
                <!-- chnage later for Settings Processing -->
                <!-- <li class="nav-sub-item" *ngFor="let header of headerlist.processing;"><a class="nav-sub-link"
                    [id]="header.master_name"  
                    (click)="redirectProcessing(header);colorchnage(header.master_name)">{{header.master_name}}</a></li> -->
                <!-- temparory hide coz not in flow -->
                <!-- <li *ngIf="GenerateRegnNoView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Generate Regn No" class="nav-sub-link"
                    (click)="redirectProcessing1('/assign-registration','')">
                    Generate Regn No
                  </a></li> -->
                <li *ngIf="GenerateRollNoView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Generate Roll No" class="nav-sub-link" (click)="redirectProcessing1('/result-process','O')">
                    Generate Roll No
                  </a></li>
                <li *ngIf="GenerateSheetsView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Generate Control Sheets" class="nav-sub-link"
                    (click)="redirectProcessing1('/result-process','C')">
                    Generate Control Sheets
                  </a></li>
                <li *ngIf="GenerateCodesView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Generate Codes" class="nav-sub-link" (click)="redirectProcessing1('/result-process','D')">
                    Generate Codes
                  </a></li>
                <li *ngIf="CenterCodesView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Center Codes"
                    class="nav-sub-link" (click)="redirectProcessing1('/center-codes','')">
                    Center Codes
                  </a></li>
                <li *ngIf="ZoneAllocationView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Zone Allocation" class="nav-sub-link" (click)="redirectProcessing1('/result-process','')">
                    Zone Allocation
                  </a></li>
                <li *ngIf="GenerateMarksFoilsView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Generate Marks Foils" class="nav-sub-link" (click)="redirectProcessing1('/result-process','F')">
                    Generate Marks Foils
                  </a></li>
                <li *ngIf="ProcessResultView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Process Result" class="nav-sub-link" (click)="redirectProcessing1('/result-process','R')">
                    Process Result
                  </a></li>
                <li *ngIf="UpdateResultsView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Update Results" class="nav-sub-link" (click)="redirectProcessing1('/result-process','U')">
                    Update Results
                  </a></li>
                <li *ngIf="ReProcessResultView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Re-Process Result (Changes)" class="nav-sub-link"
                    (click)="redirectProcessing1('/result-process','RP')">
                    Re-Process Result (Changes)
                  </a></li>
                <li *ngIf="SwitchSessionView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Switch Session" class="nav-sub-link"
                    (click)="redirectProcessing1('/session-data','switch-session')">
                    Switch Session
                  </a></li>
                   <li *ngIf="MarksDataUploadSheets" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="MarksDataUploadSheets" class="nav-sub-link"
                    [routerLink]="['/marks-data-upload-sheets']">
                    Marks Data Upload Sheets
                  </a></li>
                   <li *ngIf="Buffer_Student_Answersheet" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Buffer_Student_Answersheet" class="nav-sub-link"
                    [routerLink]="['/buffer-student-answersheet-code-entry']">
                    Buffer Student Answersheet Code Entry
                  </a></li>
                   <li *ngIf="ExamsEvalMarksReport" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="ExamsEvalMarksReport" class="nav-sub-link"
                    [routerLink]="['/exams-eval-marks-report']">
                    Exams Eval Marks Report
                  </a></li>
              </ul>
            </li>
            <li *ngIf="inputMenu" class="nav-item" id="inputs" (click)="changetheme('inputs')"
              (click)="toggleSubMenu('inputs')">
              <a class="nav-link with-sub">
                <i class="fa fa-file-text-o sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Inputs</span>
                <i class="angle fe fe-chevron-right"></i>
                <!-- <i class="angle fe" [class.fe-chevron-right]="!isMenuActive('inputs')" [class.fe-chevron-down]="isMenuActive('inputs')"></i> -->
              </a>
              <ul class="nav-sub minmaxadmin" [hidden]="!isMenuActive('inputs')">
                <li class="side-menu-label1"></li>
                <!-- <li class="nav-sub-item" *ngFor="let header of headerlist.inputs;"><a class="nav-sub-link"
                    [id]="header.master_name"  
                    (click)="redirectProcessing(header);colorchnage(header.master_name)">{{header.master_name}}</a></li> -->
                <li *ngIf="RegistrationView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Registration Form" class="nav-sub-link" (click)="redirectProcessing1('/Registration-Form','')">
                    Registration Form
                  </a></li>
                <li *ngIf="ExamInputView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Exam Input Form" class="nav-sub-link" (click)="redirectProcessing1('/Exam-Input-Form','')">
                    Exam Input Form
                  </a></li>
                <li *ngIf="CenterView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Center Allocation"
                    class="nav-sub-link" (click)="redirectProcessing1('/Center-Allocation','')">
                    Center Allocation
                  </a></li>
                  <li *ngIf="New_CenterView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Center Allocation and Seat No"
                    class="nav-sub-link" (click)="redirectProcessing1('/new-center-allocation','')">
                    Center Allocation and Seat No
                  </a></li>
                <!-- <li *ngIf="CollegeCapacity" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Center Allocation"
                    class="nav-sub-link" (click)="redirectProcessing1('/college-capacity','')">
                    College Capcity
                  </a></li> -->
                <li *ngIf="BarcodeNameView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Barcode Name Slips" class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','2')">
                    Barcode Name Slips
                  </a></li>
                <li *ngIf="BarcodeMarksView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Barcode Marks Slips" class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','5')">
                    Barcode Marks Slips
                  </a></li>
                 <li *ngIf="PracticalMarks"  class="nav-sub-item" (click)="$event.stopPropagation()"><a id="UploadStudentData" class="nav-sub-link"
                    [routerLink]="['/Practical-Marks']">
                    Practical Mark Entry 
                  </a></li>
                  <li class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="TheoryExamAppointment" class="nav-sub-link" [routerLink]="['/Theory-Exam-Appointment']">
                    Theory Exam Appointment
                  </a>
                </li>
               
                <li *ngIf="ControlSheetsView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Control Sheets" class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','6')">
                    Control Sheets
                  </a></li>
                <li *ngIf="MarksByRollNoView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Marks By Roll No" class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','7')">
                    Marks By Roll No
                  </a></li>
                <li *ngIf="MarksByCodeView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Marks By Code" class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','8')">
                    Marks By Code
                  </a></li>
                <li *ngIf="StatusReportView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Status Report" class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','11')">
                    Status Report
                  </a></li>

                <li *ngIf="ChangeMarksView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Change Marks"
                    class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','14')">
                    Change Marks
                  </a></li>
                <li *ngIf="SectionMarksView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Section Marks" class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','15')">
                    Section Marks
                  </a></li>
                <li *ngIf="DistAssMarksView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Dist Ass Marks" class="nav-sub-link" (click)="redirectProcessing1('/Marks-Entry','16')">
                    Dist Ass Marks
                  </a></li>
                <li *ngIf="StudentStatus" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="StudentStatus" class="nav-sub-link"
                    [routerLink]="['/Student-Status']">
                    Student Status
                  </a></li>
                <li *ngIf="RevaluationView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="RevaluationView" class="nav-sub-link"
                    [routerLink]="['/revaluation-result']">
                    Revaluation
                  </a></li>
                <li *ngIf="PackingList" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="PackingList" class="nav-sub-link"
                    [routerLink]="['/packing-list']">
                    Packing List
                  </a></li>
                <li *ngIf="SubjectChange" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="SubjectChange" class="nav-sub-link"
                    [routerLink]="['/subject-change']">
                    Subject Change
                  </a></li>
                  <li *ngIf="AdminOptionalSubjectSelection" class="nav-sub-item" (click)="$event.stopPropagation()">
                    <a id="AdminOptionalSubjectSelection" class="nav-sub-link" [routerLink]="['/admin-optional-subject-selection']">
                       Optional Subject Selection
                    </a>
                  </li>
                <li *ngIf="WithHold" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="WithHold" class="nav-sub-link"
                    [routerLink]="['/with-hold']">
                    WithHold Cases
                  </a></li>
                  <li *ngIf="UploadStudentData" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="UploadStudentData" class="nav-sub-link"
                    [routerLink]="['/Upload-Student-Data']">
                    Upload StudentData 
                  </a></li>

                <!-- <li *ngIf="IAMarksView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="IAMarks" class="nav-sub-link" [routerLink]="['/ia-marks']">
                    IA Marks
                  </a></li> -->
              </ul>
            </li>
            <li *ngIf="settingMenu" class="nav-item" id="settings" (click)="changetheme('settings')"
              (click)="toggleSubMenu('settings')">
              <a class="nav-link with-sub">
                <i class="fa fa-cogs sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Exam Form Settings</span>
                <i class="angle fe fe-chevron-right"></i>
                <!-- <i class="angle fe" [class.fe-chevron-right]="!isMenuActive('settings')" [class.fe-chevron-down]="isMenuActive('settings')"></i> -->
              </a>
              <ul class="nav-sub minmaxadmin" [hidden]="!isMenuActive('settings')">
                <li class="side-menu-label1"></li>
                <!-- <li class="nav-sub-item" *ngFor="let header of headerlist.settings;"><a class="nav-sub-link"
                    [id]="header.master_name"  
                    (click)="redirect(header.path);colorchnage(header.master_name)">{{header.master_name}}</a></li> -->
                <li *ngIf="StudentProfileSettingView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Student Profile" class="nav-sub-link" [routerLink]="['/student-profile-settings']">
                    Student Profile
                  </a></li>
                <li *ngIf="ExamSetupView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Exam Setup"
                    class="nav-sub-link" [routerLink]="['/exam-setup']">
                    Exam Setup
                  </a></li>
                <li *ngIf="FeeHeadView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Fee Head"
                    class="nav-sub-link" [routerLink]="['/Fee-Head']">
                    Fee Head
                  </a></li>
                <li *ngIf="FeeTemplateView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Fee Template"
                    class="nav-sub-link" [routerLink]="['/Fee-Templet']">
                    Fee Template
                  </a></li>
                <li *ngIf="FeeTemplateMappingView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Fee Template Mapping" class="nav-sub-link" [routerLink]="['/Fee-Templet-Mapping']">
                    Fee Template Mapping
                  </a></li>
                <li *ngIf="FeeModeView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Fee Mode"
                    class="nav-sub-link" [routerLink]="['/Fee-Setting']">
                    Fee Mode
                  </a></li>
                <li *ngIf="ApplyFeeTemplateView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Apply Fee Template" class="nav-sub-link" [routerLink]="['/apply-fee']">
                    Apply Addmission Fee
                  </a></li>
                <li *ngIf="examFeeView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Apply Exam Fee "
                    class="nav-sub-link" [routerLink]="['/Exam-Fee']">
                    Apply Exam Fee
                  </a></li>
                <li *ngIf="ScrutinyApprovalView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Scrutiny Approval" class="nav-sub-link" [routerLink]="['/scrutiny']">
                    Scrutiny Approval
                  </a></li>
                <li *ngIf="StudentAttendanceView && !SkipAttendance" class="nav-sub-item"
                  (click)="$event.stopPropagation()"><a id="Student Attendance" class="nav-sub-link"
                    [routerLink]="['/student-attendance']">
                    Attendance
                  </a></li>
                <!-- <li *ngIf="StudentIAAttendanceView && !SkipAttendance" class="nav-sub-item"
                  (click)="$event.stopPropagation()"><a id="Student Practical Attendance" class="nav-sub-link"
                    [routerLink]="['/student-ia-attendance']">
                    Practical Attendance
                  </a></li> -->
                <li *ngIf="holidayView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="Student Practical Attendance" class="nav-sub-link" [routerLink]="['/holiday-dates']">
                    Holiday Dates
                  </a></li>
                <li *ngIf="ParameterView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Parameter Data"
                    class="nav-sub-link" [routerLink]="['/parameter-data']">
                    Parameter
                  </a></li>
                <li *ngIf="ComplaintView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="Complaint Data"
                    class="nav-sub-link" [routerLink]="['/complaint']">
                    Grievance
                  </a></li>
                <li *ngIf="AdminUser" class="nav-sub-item" [routerLink]="['/TclcScrutiny']"
                  (click)="$event.stopPropagation()">
                  <a class="nav-sub-link">Student Requests
                  </a>
                </li>
                <!-- <li *ngIf="SLMView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="slm" class="nav-sub-link"
                      [routerLink]="['/slm']">
                      SLM </a></li> -->

                <li *ngIf="notificationsView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="notifications" class="nav-sub-link" [routerLink]="['/notifications']">
                    Publish Notifications
                  </a></li>

                <li *ngIf="tentativeView" class="nav-sub-item" (click)="$event.stopPropagation()"><a id="tentative"
                    class="nav-sub-link" [routerLink]="['/tentative-schedule-master']">
                    Tentative Exam Schedule
                  </a></li>


                <li *ngIf="tentativeDetailsView" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="tentativedetails" class="nav-sub-link" [routerLink]="['/tentative-schedule-details']">
                    Tentative Descriptive Schedule
                  </a></li>
                <li *ngIf="UploadStudentPhotoAndSign" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="UploadStudentPhotoAndSign" class="nav-sub-link" [routerLink]="['/StudentSignPhotoUpload']">
                    Upload Student Photo And Sign
                  </a></li>
                    <li *ngIf="UploadOldStudentPhotoAndSign" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="UploadOldStudentPhotoAndSign" class="nav-sub-link" [routerLink]="['/OldStudentSigphUpload']">
                   Old Student Photo And Sign Upload
                  </a></li>
                   <li *ngIf="UploadConvocation" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="UploadConvocation" class="nav-sub-link" [routerLink]="['/convocation']">
                   Convocation
                  </a></li>
                <li *ngIf="ExamFormCollegeReport" class="nav-sub-item" (click)="$event.stopPropagation()"><a
                    id="ExamFormCollegeReport" class="nav-sub-link" [routerLink]="['/ExamFormReportCollegewise']">
                    Student Exam Form College Report
                  </a></li>
                <li *ngIf="IAMarks" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="IAMarks" class="nav-sub-link" [routerLink]="['/IAMarks']">
                    IA Marks
                  </a>
                </li>
                <li *ngIf="ElectiveMarks" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="ElectiveMarks" class="nav-sub-link" [routerLink]="['/ElectiveMarks']">
                    Elective Marks
                  </a>
                </li>
                <li *ngIf="IAMarks" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="IAMarks" class="nav-sub-link" [routerLink]="['/IAMarkCountReport']">
                    IA Marks Count Report
                  </a>
                </li>
                 <li *ngIf="IAMarks" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="IAMarks" class="nav-sub-link" [routerLink]="['/IA-Marks-Report']">
                    IA Marks Report
                  </a>
                  </li>
                  <li *ngIf="PracticalMarksReport" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="PracticalMarksReport" class="nav-sub-link" [routerLink]="['/practical-marks-report']">
                    Practical Marks Report
                  </a>
                  </li>
                   <li *ngIf="collegewiselist" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="collegewislist" class="nav-sub-link" [routerLink]="['/collegewise-student-name-list']">
                    Student Summary Report
                  </a>
                  </li>
                   <li *ngIf="StudentHoldData" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="StudentHoldData" class="nav-sub-link" [routerLink]="['/Student-Hold-Data']">
                    Student WithHeld Release
                  </a>
                </li>
                   <li *ngIf="StudentSignPhotoUploadReport" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="StudentSignPhotoUploadReport" class="nav-sub-link" [routerLink]="['/student-sign-photo-upload-report']">
                    Student Data Upload Report
                  </a>
                </li>
                 <li *ngIf="BlockWiseReport" class="nav-sub-item" (click)="$event.stopPropagation()">
                  <a id="BlockWiseReport" class="nav-sub-link" [routerLink]="['/Block-Wise-Report']">
                    Exam Attendance Report
                  </a>
                </li>
              </ul>
            </li>
            <!-- {
              path: 'student-ia-attendance',
              component:  IaAtdComponent
            },
            {
              path: 'ia-attendance',
              component:  IaAtdSettingComponent
            },
            -->
            <!-- 
            <li class="nav-item" id="Fees" (click)="changetheme('Fees')">
              <a class="nav-link with-sub">
                <i class="fa fa-user sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Fees</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul class="nav-sub minmaxadmin ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" *ngFor="let header of headerlist.Fees;"><a  class="nav-sub-link"  [id]="header.master_name"
                    (click)="redirectProcessing(header);colorchnage(header.master_name)">{{header.master_name}}</a></li>
              </ul>
            </li> -->
            <!-- <li   class="nav-item" id="CentreAssignmentReports" 
            (click)="changetheme('CentreAssignmentReports')">
              <a class="nav-link with-sub">
                <i class="fa fa-user sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Centre Assignment Reports</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul class="nav-sub minmaxadmin ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" *ngFor="let header of headerlist.CentreAssignmentReports;"><a  class="nav-sub-link"  [id]="header.master_name"
                    (click)="redirectProcessing(header);colorchnage(header.master_name)">{{header.master_name}}</a></li>
              </ul>
            </li>
            <li  class="nav-item" id="CourseReports" (click)="changetheme('CourseReports')">
              <a class="nav-link with-sub">
                <i class="fa fa-user sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Course Reports</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul class="nav-sub minmaxadmin ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" *ngFor="let header of headerlist.CourseReports;"><a  class="nav-sub-link"  [id]="header.master_name"
                    (click)="redirectProcessing(header);colorchnage(header.master_name)">{{header.master_name}}</a></li>
              </ul>
            </li>
            <li   class="nav-item" id="Post_Exam_Reports" (click)="changetheme('Post_Exam_Reports')">
              <a class="nav-link with-sub">
                <i class="fa fa-user sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Post Exam Reports</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul class="nav-sub minmaxadmin ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" *ngFor="let header of headerlist.Post_Exam_Reports;"><a  class="nav-sub-link"  [id]="header.master_name"
                    (click)="redirectProcessing(header);colorchnage(header.master_name)">{{header.master_name}}</a></li>
              </ul>
            </li>
            <li  class="nav-item" id="PreExamReports" (click)="changetheme('PreExamReports')">
              <a class="nav-link with-sub">
                <i class="fa fa-user sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Pre Exam Reports</span>
                <i class="angle fe fe-chevron-right"></i>
              </a>
              <ul class="nav-sub minmaxadmin ">
                <li class="side-menu-label1"></li>
                <li class="nav-sub-item" *ngFor="let header of headerlist.PreExamReports;"><a  class="nav-sub-link"  [id]="header.master_name"
                    (click)="redirectProcessing(header);colorchnage(header.master_name)">{{header.master_name}}</a></li>
              </ul>
            </li> -->
            <li *ngIf="reportMenu" class="nav-item" id="Reports" (click)="changetheme('Reports')"
              (click)="toggleSubMenu('Reports')">
              <a class="nav-link with-sub">
                <i class="fa fa-file-excel-o sidemenu-icon menu-icon "></i>
                <span class="sidemenu-label">Reports</span>
                <i class="angle fe fe-chevron-right"></i>
                <!-- <i class="angle fe" [class.fe-chevron-right]="!isMenuActive('Reports')" [class.fe-chevron-down]="isMenuActive('Reports')"></i> -->
              </a>
              <ul class="nav-sub minmaxadmin" [hidden]="!isMenuActive('Reports')">
                <li class="side-menu-label1" (click)="$event.stopPropagation()"></li>
                <li class="nav-sub-item" *ngFor="let header of headerlist.Reports;" (click)="$event.stopPropagation()">
                  <a class="nav-sub-link" [id]="header.master_name"
                    (click)="redirectProcessing(header);colorchnage(header.master_name)">{{header.master_name}}</a>
                </li>
              </ul>
            </li>
          </ul>
          <div class="slide-right" id="slide-right"><i class="fe fe-chevron-right"></i></div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Sidemenu -->
  <!-- Main Content-->
  <router-outlet class="mt-3" *ngIf="aaa"></router-outlet>
  <!-- End Main Content-->

  <!-- Main Footer-->

  <div class="main-footer text-center border-top">
    <div class="container">
      <div class="row row-sm">
        <div class="col-md-12">
          <span>Copyright © {{date}} <a>SMB Group</a> All rights reserved.</span>
        </div>
      </div>
    </div>
  </div>
  <!--End Footer-->
</div>